var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoinEmpty = function SvgCoinEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#coin-empty_svg__a)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.32,
    d: "M18 0c9.942 0 18 8.06 18 18s-8.058 18-18 18S0 27.94 0 18 8.058 0 18 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.4,
    d: "M18 3.375C9.922 3.375 3.375 9.923 3.375 18S9.923 32.625 18 32.625 32.625 26.077 32.625 18 26.078 3.375 18 3.375m0 27c-6.834 0-12.375-5.54-12.375-12.375 0-6.834 5.54-12.375 12.375-12.375 6.834 0 12.375 5.54 12.375 12.375 0 6.834-5.54 12.375-12.375 12.375"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "coin-empty_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
};
export default SvgCoinEmpty;